import { ASSIGN_ACTION_NAME, DONE_TRANSITION_ACTION_NAME, ERROR_TRANSITION_ACTION_NAME, EVENTLESS_TRANSITION_ACTION_NAME, INITIAL_TRANSITION_ACTION_NAME } from './constants';
export function isDevelopment() {
  return process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
}
export function isAssignAction(event) {
  if (typeof event !== 'object') {
    return false;
  }
  return event.type === ASSIGN_ACTION_NAME;
}
export function isServiceNode(node) {
  if (typeof node !== 'object') {
    return false;
  }
  return 'invoke' in node;
}
export function isEventlessTransition(node) {
  if (typeof node !== 'object') {
    return false;
  }
  return 'always' in node;
}
export function getActionByName(machine, name) {
  const actions = machine.actions || {};
  const actionByName = actions[name];
  if (actionByName) {
    return actionByName;
  }
  if (isDevelopment()) {
    throw new Error(`Action "${name}" not found`);
  } else {
    return () => {};
  }
}
export function getServiceByName(machine, name) {
  if (typeof name === 'string') {
    const services = machine.services || {};
    const serviceByName = services[name];
    if (serviceByName) {
      return serviceByName;
    }
    if (isDevelopment()) {
      throw new Error(`Service "${name}" not found. Make sure it's imported and added to the services object.`);
    } else {
      return async () => {};
    }
  }
  return name;
}
export function getInitialState(machine) {
  return machine.initial || Object.keys(machine.states)[0];
}
export function getEventName(event) {
  return typeof event === 'string' ? event : event.type;
}
export function getEventData(event) {
  return typeof event === 'string' ? null : event.data || null;
}
export function getTransitionTarget(transition) {
  return typeof transition === 'string' ? transition : transition.target;
}
export function getTransitionActions(transition) {
  return typeof transition === 'string' ? [] : transition.actions || [];
}
export function getTransitionCondition(transition) {
  return typeof transition === 'string' ? null : transition.cond || null;
}
export function makeArray(item) {
  return Array.isArray(item) ? item : [item];
}
export function tinyUUID() {
  return Math.random().toString(36).slice(-6);
}
export function isInternalEvent(event) {
  return event.type === EVENTLESS_TRANSITION_ACTION_NAME || event.type === INITIAL_TRANSITION_ACTION_NAME || event.type === DONE_TRANSITION_ACTION_NAME || event.type === ERROR_TRANSITION_ACTION_NAME;
}